
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-kepala-skb/pegawai",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-kepala-skb/pegawai/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-kepala-skb/pegawai"])
      });
    }
  